import { ChevronLeft, ChevronRight } from '@carbon/icons-react';
import * as React from 'react';

import { useNavbarSchema } from 'bones/components/molecules/Navbar/context/NavbarSchema';
import { Button } from 'bones/design-system/components/Button';

export const NavbarExpand: React.VFC = () => {
  const { expand } = useNavbarSchema();

  return (
    <div className="vb-navbar-expand">
      <Button
        className="vb-navbar-expand-button"
        leftIcon={expand.isExpanded ? ChevronLeft : ChevronRight}
        onClick={expand.onClick}
        size="xs"
        testId={expand.testId}
        variant="primary-accent"
      />
    </div>
  );
};
